<template>
  <div class="list-box">
    <div class="goods-type">
      <div class="type-box">
        <div class="lable">品牌</div>
        <div class="type-list">
          <!-- <span class="red">不限</span> -->
          <span class="navitem" v-for="(navitem, i) in navList" :key="i"><img :src="navitem.BrandPic" alt=""></span>
        </div>
      </div>
      <!-- <div class="type-box">
        <div class="lable">总容积</div>
        <div class="type-list">
          <span class="red">不限</span>
          <span v-for="j in 12" :key="j">Haier/海尔</span>
        </div>
      </div> -->
      <div class="type-box">
        <div class="lable">类型</div>
        <div class="type-list">
          <!-- <span class="red">不限</span> -->
          <span class="txt" v-for="(brand, brandId) in brandList" :key="brandId">{{brand.TypeName}}</span>
        </div>
      </div>
      <!-- <div class="type-box">
        <div class="lable">价格</div>
        <div class="type-list">
          <span class="red">不限</span>
          <span v-for="i in 4" :key="i">180L以下</span>
        </div>
      </div> -->
    </div>
    <div class="price-switch">
      <div class="btn" :class="{activeBtn : btnIndex == 1}" @click="ckeckClick(1)">默认</div>
      <div class="btn" :class="{activeBtn : btnIndex == 2}" @click="ckeckClick(2)">销量</div>
      <div class="price">
        <span style="margin-right:10px;">价格</span>
        <div class="input-price" :class="{showBtn:isShowBtn}" @mouseenter="mouseenterFun" @mouseleave="mouseleaveFun">
          <div class="input-box">
            <el-input size="mini" placeholder="￥" style="width:58px;" v-model="minPrice"></el-input> - 
            <el-input size="mini" placeholder="￥" style="width:58px;" v-model="maxPrice"></el-input>
          </div>
          <div class="price-btn" v-show="isShowBtn">
            <el-button size="mini" @click="cleanUp">清除</el-button>
            <el-button size="mini" @click="confirm">确认</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="goods-list">
      <ax-goods class="goods-box" v-for="(item, index) in goodsList" :key="index" :goodsData="item"></ax-goods>
    </div>
  </div>
</template>
<script>
import {
  NaviDetail,
  BusinessNaviSpuList,
  BusinessBrandTypeData
} from '../../api/api'
export default {
  name: 'airCondition',
  data(){
    return{
      btnIndex: 1,
      navList: [],
      goodsList: [],
      minPrice: null,
      maxPrice: null,
      isShowBtn: false,
      brandList: []
    }
  },
  created(){
    this.getNavList()
    this.getBusinessNaviSpuList()
    this.getBrandType()
  },
  methods:{
    cleanUp(){
      this.minPrice = null
      this.maxPrice = null
    },
    confirm(){
      let params = {
        naviId: 1,
        typeId: 1,
        minPrice: this.minPrice,
        maxPrice: this.maxPrice,
        sortBy: 0,
        pageIndex: 1,
        pageSize: 30
      }
      BusinessNaviSpuList(params).then(res => {
        if(res.data.success){
          this.goodsList = res.data.response.data || []
        } else{
          this.$message.error(res.data.msg)
        }
      })
    },
    mouseenterFun(){
      this.isShowBtn = true
    },
    mouseleaveFun(){
      this.isShowBtn = false
    },
    ckeckClick(val){
      this.btnIndex = val
    },
    getNavList(){
      NaviDetail({naviId:1}).then(res => {
        if(res.data.success){
          this.navList = res.data.response.Brands || []
        } else{
          this.$message.error(res.data.msg)
        }
      })
    },
    getBusinessNaviSpuList(){
      let params = {
        naviId: 1,
        typeId: 1,
        sortBy: 0,
        pageIndex: 1,
        pageSize: 30
      }
      BusinessNaviSpuList(params).then(res => {
        if(res.data.success){
          this.goodsList = res.data.response.data || []
        } else{
          this.$message.error(res.data.msg)
        }
      })
    },
    getBrandType(){
      let params = {
        naviId: 1,
        typeId: 1
      }
      BusinessBrandTypeData(params).then(res => {
        if(res.data.success){
          this.brandList = res.data.response.Types || []
        } else{
          this.$message.error(res.data.msg)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.list-box{
  width: 1200px;
  margin: 0 auto;
  padding-top: 20px;
  .goods-type{
    text-align: left;
    span{
      display: inline-block;
      font-size: 14px;
      color: #333333;
      line-height: 20px;
    }
    .type-box{
      margin-bottom: 30px;
      display: flex;
      justify-content: flex-start;
      .lable{
        // flex: 1;
        width: 80px;
        text-align: center;
        font-weight: bold;
      }
      .type-list{
        padding-left: 10px;
        flex: 1;
        .navitem{
          // margin-right: 34px;
          // margin-bottom: 20px;
          width: 130px;
          height: 70px;
          border: 1px solid #EAEAEA;
          display: inline-block;
          cursor: pointer;
          >img{
            width: 100%;
            height: 100%;
          }
        }
        .txt{
          margin-right: 24px;
          display: inline-block;
          font-weight: 700;
          color: #666;
          cursor: pointer;
        }
        .txt:hover{
          color: #f40000;
        }
        .red{
          font-weight: bold;
          color: #f40000;
        }
      }
    }
  }
  .price-switch{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background: #ffffff;
    margin-bottom: 16px;
    .btn{
      font-size: 14px;
      width: 72px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      cursor: pointer;
      margin-right: 20px;
    }
    .activeBtn{
      width: 70px;
      height: 38px;
      line-height: 38px;
      border: 1px solid #f40000;
    }
    .price{
      width: 200px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      .input-price{
        position: absolute;
        width: 140px;
        border: 1px solid #fff;
        padding: 5px 0;
        z-index: 20;
        left: 40px;
        top: -10px;
        .price-btn{
          margin-top: 10px;
        }
      }
      .showBtn{
        border: 1px solid #999;
        background: #ffffff;
      }
    }
  }
  .goods-list{
    width: 1200px;
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;
    .goods-box{
      margin-bottom: 16px;
      margin-right: 16px;
    }
    .goods-box:nth-child(4n){
      margin-right: 0;
    }
  }
}
</style>